import { useCallback, useEffect, useState } from "react";
import {
  DEV_MODE_OVERRIDE_STORAGE_KEY,
  readDeveloperModeFlag,
  subscribeDeveloperModeFlag,
  writeDeveloperModeFlag,
} from "./developerModeState";

export { DEV_MODE_OVERRIDE_STORAGE_KEY, readDeveloperModeFlag, writeDeveloperModeFlag };

export function useDeveloperModeFlag() {
  const [isDeveloperMode, setIsDeveloperModeState] = useState(() => readDeveloperModeFlag());

  useEffect(() => {
    return subscribeDeveloperModeFlag((nextValue) => {
      setIsDeveloperModeState(!!nextValue);
    });
  }, []);

  const setIsDeveloperMode = useCallback((nextValue) => {
    writeDeveloperModeFlag(!!nextValue);
    setIsDeveloperModeState(!!nextValue);
  }, []);

  return {
    isDeveloperMode,
    setIsDeveloperMode,
  };
}

// Backwards-compatible export alias.
export const useDeveloperModeTools = useDeveloperModeFlag;
